<template>
    <!-- Contact Form -->
    <section id="contactus" class="wrapper style2">
        <div class="inner">
            <header class="align-center">
                <p class="special">{{subtitle}}</p>
                <h2>{{header}}</h2>
            </header>
            <br />
            <div id="contactus_statusmsg" class="row align-center" v-show="statusVisible === true"><ul></ul></div>
            <div class="grid-style">
                <div class="two-thirds">
                    <form id="app" @submit="submitForm" action="/send-email" method="post">
                        <div class="row uniform">
                            <div class="12u$">
                                <input type="text" name="name" id="contact_name" value="" placeholder="Nome" />
                            </div>
                            <div class="6u 12u$(xsmall)">
                                <input type="tel" name="phone" id="contact_phone" value="" placeholder="Telefone" />
                            </div>
                            <div class="6u$ 12u$(xsmall)">
                                <input type="email" name="email" id="contact_email" value="" placeholder="Email" />
                            </div>
                            <div class="12u$">
                                <div class="select-wrapper">
                                    <select name="category" id="contact_category">
                                        <option value="-1">- Categoria de Serviço -</option>
                                        <option v-for="service in services" :key="service.id" :value="service.id" v-html="service.title"></option>
                                        <option value="0">Mensagem Geral</option>
                                    </select>
                                </div>
                            </div>
                            <!-- Break -->
                            <div class="12u$">
                                <textarea name="message" id="contact_message" placeholder="Entra sua messagem ou detais de trabalho" rows="6"></textarea>
                            </div>
                            <!-- Break -->
                            <div class="12u$">
                                <ul class="actions">
                                    <li><input type="submit" value="Enviar Mensagem"/></li>
                                    <li><input type="reset" value="Clara" class="alt" v-on:click="resetForm"/></li>
                                </ul>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="one-third">
                    <p v-html="contactText"></p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import vue from 'vue'
import axios from 'axios'
import vueaxios from 'vue-axios'

vue.use(vueaxios, axios);

export default {
    props : {
        services : Array,
        currentServiceId : Number,
        contactInfo : {}
    },
    data() {
        return {
            header : 'OBTER UMA COTAÇÃO',
            subtitle : 'Vamos conversar',
            statusWrapper : null,
            statusListItems : null,
            nameField :  null,
            emailField : null,
            phoneField : null,
            categoryField : null,
            messageField : null,
            statusVisible : false,
            isSubmitEnabled : true
        }
    },
    mounted : function() {
        this.statusWrapper = this.$el.querySelector("#contactus_statusmsg");
        this.statusListItems = this.$el.querySelector("#contactus_statusmsg ul");
        this.nameField =  this.$el.querySelector("#contact_name");
        this.emailField = this.$el.querySelector("#contact_email");
        this.phoneField = this.$el.querySelector("#contact_phone");
        this.categoryField = this.$el.querySelector("#contact_category");
        this.messageField = this.$el.querySelector("#contact_message");
    },
    watch: {
        currentServiceId: function(newVal) {
            this.setServiceDropdown(newVal);
        }
    },
    methods : {
        setServiceDropdown : function(serviceId) {
            this.categoryField.value = serviceId;
        },
        submitForm : function(e) {
            e.preventDefault();
            if (!this.isSubmitEnabled) {
                return;
            }

            this.isSubmitEnabled = false;
            this.statusListItems.innerHTML = '';
            this.statusVisible = true;
            this.statusWrapper.classList.remove("error");
            this.statusWrapper.classList.remove("success");

            let errors = this.validateForm();
            if(errors.length > 0) 
            {
                this.statusWrapper.classList.add("error");
                errors.forEach(msg => {
                    this.statusListItems.innerHTML += "<li>" + msg + "</li>";	
                });
            }
            else
            {
                let currentObj = this;
                this.axios.post('/send-email', {
                    name: this.nameField.value.trim(),
                    phone: this.phoneField.value.trim(),
                    email: this.emailField.value.trim(),
                    message: this.messageField.value.trim(),
                    category: this.categoryField.value
                })
                .then(function () {
                    currentObj.statusWrapper.classList.add("success");
                    currentObj.statusListItems.innerHTML += "<li>Mensagem enviada. Entraremos em contato em breve.</li>";
                    currentObj.isSubmitEnabled = true;
                })
                .catch(function () {
                    currentObj.statusWrapper.classList.add("success");
                    currentObj.statusListItems.innerHTML += "<li>Houve um problema inesperado. Tente novamente mais tarde ou entre em contato por telefone.</li>";
                    currentObj.isSubmitEnabled = true;
                });
            }

            var topOffset = document.querySelector("#contactus").offsetTop + this.statusWrapper.offsetTop - document.querySelector("#header").clientHeight;
            window.scrollTo({top: topOffset, behavior: "smooth"});
        },
        resetForm : function(e) {
            e.preventDefault();
            this.statusVisible = false;
            this.statusWrapper.classList.remove("error");
            this.statusWrapper.classList.remove("success");
            this.statusListItems.innerHTML = "";
            this.nameField.classList.remove("error");
            this.emailField.classList.remove("error");
            this.phoneField.classList.remove("error");
            this.messageField.classList.remove("error");

            this.nameField.value = "";
            this.phoneField.value = "";
            this.emailField.value = "";
            this.messageField.value = "";
            this.phoneField.value = "";
            this.categoryField.value = -1;
        },
        validateForm : function() {

            var errorMessage = [];
            
            this.nameField.classList.remove("error");
            this.emailField.classList.remove("error");
            this.phoneField.classList.remove("error");
            this.messageField.classList.remove("error");

            //Validate name
            if (this.nameField.value.trim() === "") {
                errorMessage.push("Insira um nome");
                this.nameField.classList.add("error");
            }
            else if (/^[a-zA-Z\s]*$/.test(this.nameField.value.trim()) == false) {
                errorMessage.push("Somente letras permitidas no nome");
                this.nameField.classList.add("error");
            }
            
            //Validate email and/or phone (not actually validating phone number)
            var re = /^(([^<>()\\.,;:\s@"]+(\.[^<>()\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (this.emailField.value.trim() === '' && this.phoneField.value.trim() === '') {
                errorMessage.push("Insira um email ou número de telefone");
                this.emailField.classList.add("error");
                this.phoneField.classList.add("error");
            }
            else if (re.test(this.emailField.value.trim()) == false) {
                errorMessage.push("O email está em formato incorreto");
                this.emailField.classList.add("error");
            }

            //Validate that message isn't blank
            if (this.messageField.value.trim() === '') {
                errorMessage.push("Digite uma mensagem");
                this.messageField.classList.add("error");
            }


            return errorMessage;
        }
    },
    computed : {
        contactText : function() {
            return this.contactInfo.text.join("");
        }
    }
}
</script>

<style scoped>
#contactus form input[type="text"].error,
#contactus form input[type="password"].error,
#contactus form input[type="email"].error,
#contactus form input[type="tel"].error,
#contactus form select.error,
#contactus form textarea.error{
	border-color: red;
	box-shadow: red;
}
#contactus #contactus_statusmsg ul {
	width: 100%;
	list-style: none;
}
#contactus #contactus_statusmsg.error {
	color: red;
}
#contactus #contactus_statusmsg.success {
	color: green;
}
#contactus div.two-thirds {
    width: 66%;
}
#contactus div.one-third {
    width: 33%;
}
@media screen and (max-width: 1000px) {
    #contactus div.two-thirds {
        width: inherit;
    }
    #contactus div.one-third {
        width: inherit;
    }
}
</style>